import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-aws-redirection-failed',
  templateUrl: './aws-redirection-failed.component.html',
  styleUrls: ['./aws-redirection-failed.component.scss'],
})
export class AwsRedirectionFailedComponent  implements OnInit {

  constructor(
    private router: Router
  ) { }

  ngOnInit() {
  }

  gotoLogin() {
    this.router.navigate(["/login"]);
  }

}
